import { render, staticRenderFns } from "./OtpVerify.html?vue&type=template&id=7f8cc96f&scoped=true&"
import script from "./OtpVerify.js?vue&type=script&lang=js&"
export * from "./OtpVerify.js?vue&type=script&lang=js&"
import style0 from "./OtpVerify.scss?vue&type=style&index=0&id=7f8cc96f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8cc96f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
